import makeStyles from '@material-ui/core/styles/makeStyles';
import { TOOLBAR_HEIGHT } from 'components/Layout';
import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';
import { Space } from 'v2/components/Shared/Space';
import TableOptions from 'v2/components/Shared/TableOptions';
import ordersService from 'v2/services/orders';

const useStyle = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    background: '#ffff',
    boxShadow: '0 1px 0 0 rgba(0,0,0,0.07)',
    width: '100%',
    marginBottom: 60,
    position: 'sticky',
    top: TOOLBAR_HEIGHT,
    zIndex: 15,
    textAlign: 'center',
  },
  '@media screen and (min-width: 600px)': {
    root: {
      background: '#ffff',
      boxShadow: '0 1px 0 0 rgba(0,0,0,0.07)',
      position: 'sticky',
      bottom: 0,
      zIndex: 15,
      width: '100%',
      marginBottom: theme.spacing(2),
    },
  },
}));

const LabelGenerator = () => {
  const classes = useStyle({});

  const [isLoading] = useObservable(() => ordersService.isLoading(), []);
  const [orders] = useObservable(() => ordersService.getOrders(), []);

  const onUnCheckAll = useCallback(() => ordersService.unCheckAllOrders(), []);

  const onGenerateLabels = useCallback(() => ordersService.generateLabel(), []);

  const ordersChecked = (orders || []).filter((o) => o.checked);

  const qtOrderChecked = ordersChecked.length;

  if (isLoading || qtOrderChecked < 1) {
    return null;
  }

  const options = [
    {
      label: 'Cancelar',
      callback: onUnCheckAll,
    },
    {
      icon: 'local_play',
      label: 'Gerar etiquetas',
      color: 'primary' as const,
      callback: onGenerateLabels,
    },
  ];

  const styles = {
    top: 0,
    padding: 16,
    borderRadius: 0,
  };

  return (
    <div className={classes.root} id='label-generator' style={{ top: TOOLBAR_HEIGHT }}>
      <TableOptions items={qtOrderChecked} style={styles} options={options} />
      <Space axis='vertical' size={16} />
    </div>
  );
};

export default LabelGenerator;
